import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/GlobalStyle';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Contact from './components/Contact';
import Benefits from './components/Benefits';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';

const lightTheme = {
  primary: '#4a6cf7',
  primaryHover: '#3a56d4',
  secondary: '#6c757d',
  text: '#333',
  textLight: '#6c757d',
  background: '#ffffff',
  backgroundAlt: '#f8f9fa',
  backgroundDark: '#212529',
  border: '#e9ecef',
  success: '#28a745',
  warning: '#ffc107',
  danger: '#dc3545',
  boxShadow: '0 5px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  maxWidth: '1200px',
  headerHeight: '80px',
  glowColor: 'rgba(74, 108, 247, 0.5)'
};

const darkTheme = {
  primary: '#6d8eff',
  primaryHover: '#5a75e6',
  secondary: '#adb5bd',
  text: '#f8f9fa',
  textLight: '#ced4da',
  background: '#121212',
  backgroundAlt: '#1e1e1e',
  backgroundDark: '#000000',
  border: '#343a40',
  success: '#28a745',
  warning: '#ffc107',
  danger: '#dc3545',
  boxShadow: '0 5px 20px rgba(0, 0, 0, 0.3)',
  borderRadius: '8px',
  maxWidth: '1200px',
  headerHeight: '80px',
  glowColor: 'rgba(109, 142, 255, 0.5)'
};

function App() {
  const [theme, setTheme] = useState('light');
  
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };
  
  const currentTheme = theme === 'light' ? lightTheme : darkTheme;
  
  return (
    <LanguageProvider>
      <ThemeProvider theme={currentTheme}>
        <GlobalStyle />
        <div className={`app ${theme}`}>
          <Header theme={theme} toggleTheme={toggleTheme} />
          <Hero theme={theme} />
          <Features theme={theme} />
          <Benefits theme={theme} />
          <Contact theme={theme} />
          <Footer theme={theme} />
        </div>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
